const body = `# Getting the Inside Out

Throughout any given day, I try to keep my eyes open for quiet scenes of beauty. It's usually the little things: the specific way the afternoon light filters through a windowpane, or a simple arrangement of freshly picked flowers sitting on the kitchen counter.

Often, the recognition of these moments is incredibly fleeting. If you blink, the light shifts and the magic is gone.

Sometimes, when a scene really grabs me, I'll capture it in a digital painting. But almost inevitably, as I'm working, a quiet voice of doubt creeps in. I start to question myself: Is the beauty I'm seeing here just too mundane? Is this subject too usual? Too common?

Yet, whenever I post these paintings of everyday beauty, I am always genuinely surprised by how warmly they are received. They seem to deeply resonate with people.

I've spent some time thinking about why that is, and I think I've figured it out. Because I have already internalized that specific scene as beautiful, it feels common to me. It feels ordinary. But my perspective is entirely locked inside my own head. Nobody else knows about it. Nobody else saw the kitchen or the flowers exactly the way I did.

What has become common to me is uncommon, surprising, or entirely newly discovered by others the moment they look at my painting.

This, I've realized, is the fundamental role of an artist: getting the inside out.

I think this is the core engine that drives anyone to become an artist. You hold a view of the world that has not yet been born. It is completely invisible to everyone else until you take the time to bring it out of your head and into reality, allowing others to see the magic right alongside you.
`;

export default body;
